import { useEffect } from 'react';
import TermosUso from '../../components/TermosUso'

function TermosDeUso () {

    useEffect (() => {
        document.title = 'Termos de Uso | Gesttor'
    }, [])

    return (
        <TermosUso />
    )
}

export default TermosDeUso;